import React  from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import { grey300, grey500, red500 } from 'material-ui/styles/colors';

const DateField = props => {
  const {
    input: {
      onBlur,
      ...inputRest
    },
    label,
    helperText,
    meta: { touched, error },
    style,
    ...custom
  } = props;

  const dtf = Intl && Intl.DateTimeFormat;
  const locale = 'en';
  const err = touched && error;
  return (
    <div>
      <DatePicker
        hintText={label}
        floatingLabelText={label}
        floatingLabelFixed
        underlineStyle={{ borderColor: err ? red500 : grey300, borderBottomWidth: err ? '2px' : '1px' }}
        underlineFocusStyle={{ borderBottomWidth: '2px' }}
        DateTimeFormat={dtf}
        locale={locale}
        errorText={err}
        textFieldStyle={{
          fontSize: '14px',
          ...style
        }}
        {...inputRest}
        {...custom}
        onChange={(event, value) => {
          inputRest.onChange(value);
        }}
      />
      {helperText &&
      !err && (
        <p style={{ color: grey500, fontSize: '12px', lineHeight: '12px', marginTop: '-1px', marginBottom: 0 }}>
          {helperText}
        </p>
      )}
    </div>
  );
};

DateField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  helperText: PropTypes.string,
  meta: PropTypes.object,
  custom: PropTypes.object
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/basic/DateField.js